export default __webpack_public_path__ + "locales/de.3de1b38c8550cbf3a7234825708c0bcb.json";